import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'

import 'viewerjs/dist/viewer.css'

import VueViewer from 'v-viewer'
import Icon from '@/components/icon'
import ImgWatermark from '@/components/imgWatermark/imgWatermark'

Vue.use(VueViewer)

export default {
  components: {
    appIcon: Icon,
    appImgWatermark: ImgWatermark
  },
  data () {
    return {
      options: {
        url: 'data-source', // center if one image
        zIndex: 9999
      }
    }
  },
  computed: {
    ...mapState('tours', ['floorplan']),
    ...mapGetters('tours', ['getUnpaid']),
    images () {
      if (this.floorplan.photos) {
        return this.floorplan.photos.reduce((list, value) => {
          list.push({
            thumbnail: value.urls[1].url,
            source: value.urls[0].url
          })
  
          return list;
        }, []);
      }

      return []
    },
    files () {
      const { files = [] } = this.floorplan

      return files
    }
  },
  methods: {
    inited (viewer) {
      this.$viewer = viewer
    }
  }
}
